import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_theme_ext_RowClass} from '../../../dbschema';

export class ThemeExtensionContainerModel extends BaseContainerModel {

  bl_cms_theme_ext: bl_cms_theme_ext_RowClass = new bl_cms_theme_ext_RowClass();
}
